import React, {useContext, useEffect, useState} from 'react';
import {observer} from 'mobx-react-lite'
import SessionContext from '../../connection/SessionContext'
import {ScreenGroup} from '../../screen/ScreenGroup'
import AppContext from './AppContext'

export const AppContextProvider = observer(function AppContextProvider({children}) {

  const connection = useContext(SessionContext)
  // Bind the provider to the connection status, rerender if changed
  const [connection_status, setConn] = useState(connection.status)
  const value = new ScreenGroup(connection)

    return (
      <AppContext.Provider value={value}>
        {children}
      </AppContext.Provider>
    );

    
  })
  
